export const OV_STRINGS = {

  TICKET_NAME: '소유자 인증권',
  TICKET_UNIT: '개',
  NEXT: '다음',
  BADGE_LABEL_VERIFY: '인증 요청',


  CONFIRM_TITLE: '해당 매물의 인증을 시작할까요?',
  CONFIRM_DESC: '선택한 기간만큼 인증권이 차감됩니다.',
  PERIOD_LABEL: '인증 기간',
  PERIOD_OPTIONS: ['1개월', '2개월', '3개월'],
  TICKET_HEADER: '인증권',
  OWNED_TICKETS_LABEL: '보유 인증권',
  REQUIRED_TICKETS_LABEL: '필요 인증권',
  REMAINING_TICKETS_LABEL: '사용 후 잔여',
  INSUFFICIENT_TICKETS: '인증권이 부족합니다.',
  CHARGE_LINK: '충전하기',
  START_BUTTON: '시작하기',


  DETAIL_TITLE: '인증하는 매물의 상세 정보를\n입력해주세요',
  DETAIL_DONG: '동',
  DETAIL_FLOOR: '층',
  DETAIL_HO: '호',


  NOTICE_TITLE: '유의사항을 확인해주세요',
  NOTICE_DESC: '아래 내용을 숙지하고 동의해야 인증 요청을 진행할 수 있습니다.',
  NOTICE_ITEM_1_TITLE: (days) => `인증 배지 유효 기간 ${days}일`,
  NOTICE_ITEM_1_DESC: (days) => `인증 완료일로부터 ${days}일간 소유자 인증 배지가 유지됩니다. 만료 14일 전 갱신 알림이 발송됩니다.`,
  NOTICE_ITEM_2_TITLE: '허위 정보 및 오용에 대한 책임',
  NOTICE_ITEM_2_DESC: '허위 정보 · 위조 서류 · 허위 매물 · 사기 관련 오용에 대한 책임은 인증을 요청한 공인중개사에게 있습니다.',
  NOTICE_ITEM_3_TITLE: '이의 신청은 실패 확인 후 7일 이내',
  NOTICE_ITEM_3_DESC: '인증 실패에 대한 이의 신청 및 재처리 요청은 실패 확인일로부터 7일 이내에 제출해야 합니다.',
  NOTICE_DETAIL_TOGGLE: '상세 유의사항 전체 보기',
  NOTICE_DETAILS: [
    '1. 소유자 인증은 개인 소유자(본인), 대리인(직계존비속), 법인 소유자(대표 및 담당자)에 한하여 가능합니다.',
    '2. 인증 링크는 실제 소유자 또는 정당한 인증 권한이 있는 대상자(수임인)에게만 전달해야 합니다. 소유자와 사전 협의 없이 링크를 발송하거나, 실제 인증 대상자가 아닌 사람에게 전달해 발생하는 모든 문제의 책임은 인증을 요청한 자에게 있습니다.',
    '3. 입력한 연락처가 실제 인증 대상자의 연락처가 아니거나, 본인인증 결과와 등기 정보가 일치하지 않는 경우 인증에 실패할 수 있습니다. 이 경우 사용된 인증권은 반환되지 않습니다.',
    '4. 허위 매물 등록, 허위 정보 및 위조 서류 제출, 사기 목적의 인증 요청 등 부정한 방법으로 인증을 진행한 경우 즉시 인증이 거절 및 취소됩니다. 또한 이로 인해 발생하는 모든 민원, 법적 분쟁, 손해에 대한 책임은 인증을 요청한 자에게 있습니다.',
    '5. 디스코 시스템이 등기부 조회를 정상적으로 완료한 이후, 인증을 요청한 자 및 인증 대상자의 귀책(본인인증 실패, 정보 불일치, 서류 미비 등)으로 인해 인증에 실패할 수 있으며, 이 경우 사용된 인증권은 반환되지 않습니다. 단, 공공데이터 또는 디스코 시스템 오류로 등기 조회가 완료되지 않은 경우에 한해 인증권은 자동 반환됩니다.',
    '6. 토지와 건물의 소유자가 다른 매물(명의 분리 등)은 소유자 인증 신청 대상이 아닙니다. 신청 후 소유자 상이가 확인될 경우 인증이 거절 또는 취소되며, 이 경우 사용된 인증권은 반환되지 않습니다.',
    '7. 공동소유(공유지분) 매물의 경우, 지분 소유자 중 1인의 본인인증만 완료되어도 소유자 인증 배지가 부여됩니다. 이로 인해 소유자 간 발생할 수 있는 의견 불일치, 민원, 분쟁 등에 대한 모든 책임은 인증을 요청한 자에게 있으며 디스코는 일체 책임지지 않습니다.',
    '8. 첨부 서류는 오직 인증 권한 검토 목적으로만 사용되며, 인증 대상자에게는 전달되지 않습니다. 주민등록번호 뒷자리 등 불필요한 개인정보는 가림(음영) 처리 후 첨부해주셔야 하며, 제출된 첨부 서류는 인증 목적 달성(심사 완료) 즉시 영구 삭제처리됩니다.',
    '9. 소유자 인증 배지는 인증 완료일로부터 30~90일 동안 유지됩니다. 인증 유효기간이 지나면 인증 배지는 만료되며, 인증 표시를 유지하려면 갱신 또는 재인증이 필요합니다.',
    '10. 인증 실패에 대한 이의 신청 또는 재처리 요청은 실패 확인일로부터 7일 이내에 접수해야 합니다. 기한이 지난 요청은 검토가 제한됩니다. 단, 공공데이터 또는 디스코 시스템 오류 등 명확한 귀책사유가 확인되는 경우에는 예외적으로 검토될 수 있습니다.',
    '11. 인증 완료 후 주소, 동·호수, 지번 등 소유자 확인 기준이 되는 매물 정보를 수정하면 소유자 인증이 취소될 수 있습니다. 매물 삭제 시 적용 중인 소유자 인증 배지도 함께 종료됩니다. 이 경우 사용된 인증권은 반환되지 않습니다.',
  ],
  NOTICE_AGREE: '위 유의사항을 모두 확인하였으며, 소유자 본인 확인 후 인증 링크를 전달하겠습니다.',


  RECIPIENT_TITLE: '인증받을 사람의 정보를 입력해주세요',
  RECIPIENT_DESC: '스팸 방지를 위해 동일 링크에 최대 3회까지 발송 가능합니다.',
  RECIPIENT_TYPE_LABEL: '수신자 유형',
  RECIPIENT_TYPE_OWNER: '개인 소유자(본인)',
  RECIPIENT_TYPE_PROXY: '대리인(직계존비속)',
  RECIPIENT_TYPE_LEGAL_PROXY: '법인 소유자(대표 및 담당자)',
  RECIPIENT_NAME: '이름',
  RECIPIENT_NAME_PLACEHOLDER: '실명 입력',
  RECIPIENT_PHONE: '휴대폰 번호',
  RECIPIENT_PHONE_PLACEHOLDER: '010 - 0000 - 0000',
  RECIPIENT_OWNER_NAME: '소유자 이름',
  RECIPIENT_OWNER_RELATION: '소유자와의 관계',
  RECIPIENT_OWNER_RELATION_PLACEHOLDER: '업무상 관계 등',
  RECIPIENT_VERIFIER_NAME: '인증자 이름',
  RECIPIENT_CONFIRM_CHECKBOX: '인증 대상자와 사전 협의했으며, 입력한 연락처가 실제 인증 대상자의 연락처임을 확인했습니다.',
  RECIPIENT_ATTACHMENT_TITLE: '첨부파일',
  RECIPIENT_ATTACHMENT_UPLOAD: '+ 파일 선택하여 업로드',
  RECIPIENT_ATTACHMENT_LIMIT: '파일당 최대 100MB · 최대 10개 파일까지 업로드 가능합니다.',
  RECIPIENT_ATTACHMENT_FORMATS: 'JPG, JPEG, PNG, HEIC, PDF, HWP, DOC, DOCX, XLS, XLSX, ZIP',
  RECIPIENT_ATTACHMENT_DESC: {
    self: [
      '등기 정보와 실제 소유자 정보가 다를 경우, 상황에 맞게 다음의 서류가 필요합니다.',
      '1. 최근 소유권을 이전받은 경우: 매매계약서, 등기접수증 등 소유권 이전을 확인할 수 있는 서류',
      '2. 이름 표기나 한자 정보가 다른 경우: 신분증 사본, 가족관계증명서 등 동일인 확인이 가능한 서류',
    ],
    proxy: [
      '대리인은 직계존비속만 인증이 가능합니다. 인증에는 다음의 서류가 필요합니다.',
      '1. 소유자 신분증 사본 (주민번호 뒷자리 음영처리)',
      '2. 위임장 (주민번호 뒷자리 음영처리)',
      '3. 가족관계증명서(최근 1개월 이내, 주민번호 뒷자리 음영처리)',
    ],
    legal_proxy: [
      '법정 대리인은 대표가 신청할 경우 / 직원이 신청할 경우 상황별 각각 다음의 서류가 필요합니다.',
      '',
      '[대표]',
      '법인등기(말소사항 포함, 최근 3개월 이내)',
      '대표 신분증 사본 (주민번호 뒷자리 음영처리)',
      '',
      '[직원]',
      '1. 법인등기(말소사항 포함, 최근 3개월 이내)',
      '2. 위임장(법인인감도장 날인 필수, 주민번호 뒷자리 음영처리)',
      '3. 법인 인감증명서(최근 3개월 이내)',
      '4. 직원 신분증 (주민번호 뒷자리 음영처리)',
    ],
  },
  RECIPIENT_SUBMITTED_TITLE: '제출된 서류',
  RECIPIENT_SUBMITTED_COUNT: '첨부 파일:',
  SEND_BUTTON: '인증 신청',
  VALID_UNTIL: '까지 인증가능',


  CARRIER_LABEL: '통신사',
  CARRIERS: [
    { value: 'SKT', label: 'SKT' },
    { value: 'KT', label: 'KT' },
    { value: 'LGU', label: 'LG U+' },
    { value: 'SKT_MVNO', label: 'SKT 알뜰폰' },
    { value: 'KT_MVNO', label: 'KT 알뜰폰' },
    { value: 'LGU_MVNO', label: 'LG U+ 알뜰폰' },
  ],


  EXIT_TITLE: '작성중인 정보가\n삭제되는데 괜찮으시겠어요?',
  EXIT_DESC: '다시 인증 하려면 처음부터\n시작하게 됩니다.',
  EXIT_CONFIRM: '나가기',
  EXIT_BACK: '계속 작성하기',


  ERROR_FILE_TYPE: '해당 파일 형식은 지원하지 않습니다.',
  ERROR_FILE_SIZE: '파일당 최대 100MB까지 첨부할 수 있습니다.',
  ERROR_FILE_COUNT: '파일은 최대 10개까지 첨부할 수 있습니다.',
  ERROR_FILE_TOTAL_SIZE: '첨부파일 전체 용량은 최대 100MB까지 가능합니다.',
  ERROR_FILE_UPLOAD: '파일 업로드에 실패했습니다. 다시 시도해주세요.',
  ERROR_FILE_NETWORK: '네트워크 오류로 파일 업로드에 실패했습니다. 다시 시도해주세요.',

  ERROR_INITIATE_FAIL: '인증 요청에 실패하였습니다.',
  ERROR_VERIFICATION_IN_PROGRESS: '이미 진행 중인 소유자 인증이 있습니다.',
  ERROR_VERIFICATION_REJECTED: '반려된 인증 건이 있어 신청할 수 없습니다.',
  ERROR_RENEWAL_NOT_AVAILABLE: '아직 갱신 가능 기간이 아닙니다.',
  ERROR_TICKET_CHECK_FAIL: '인증권 정보를 불러올 수 없습니다.',
  ERROR_SEND_FAIL: '인증 메시지를 발송하지 못했습니다. 다시 시도해주세요.',
  ERROR_SEND_LIMIT: '인증 링크는 최대 3회까지 발송할 수 있습니다.',
  SUCCESS_SEND: '인증 메시지가 발송되었습니다.',
  ERROR_DUPLICATE: '이미 진행 중인 인증이 있습니다.',


  MEMBERSHIP_REQUIRED_TITLE: '소유자 인증은 멤버십 회원만\n이용할 수 있어요',
  MEMBERSHIP_REQUIRED_DESC: '멤버십 가입 후 인증권을 구매하면\n소유자 인증을 진행할 수 있어요',
  MEMBERSHIP_REQUIRED_BUTTON: '멤버십 확인하기',


  DIRECT_SHARE_MODAL_TITLE: '인증 메세지를 어떤 방식으로\n전달하시겠어요?',
  DIRECT_SHARE_COPY: '직접 복사',
  DIRECT_SHARE_SHARE: '공유하기',
  DIRECT_SHARE_TOAST: '메시지가 복사되었습니다. 원하는 곳에 붙여넣어 주세요.',
  DIRECT_SHARE_MESSAGE: (linkUrl, officeName) => {
    const office = officeName || '○○공인중개사무소';
    return `[DISCO] 소유자 인증 요청
안녕하세요, 디스코를 통해 부동산 관리를 도와드리고 있는 ${office} 공인중개사무소입니다.
의뢰하신 매물의 빠른 거래를 지원하는 '소유자 인증 배지'를 등록하고자 본인 인증을 요청드립니다.
아래 링크에서 등록된 매물 정보를 확인하신 후, 간단한 인증을 진행해 주세요.
(약 1분 소요 / 비용 없음)

■ 인증 진행하기 : ${linkUrl || ''}`;
  },
};
